<template>
  <b-modal
    id="switch-to-mentee-profile-modal"
    ref="switch-to-mentee-profile-modal"
    centered
    size="md"
    :ok-title="$t('Switch to mentee profile')"
    ok-only
    @ok="switchAccount('mentee')"
  >
    <template #modal-title>
      <span class="font-weight-bolder">{{ $t('Switch to mentee profile') }}</span>
    </template>
    <b-row>
      <b-col>
        <b-card-text class="py-1" v-if="fromMentoringPackages">
          {{ $t('Switch to mentee profile message - mentoring packages') }}
        </b-card-text>
        <b-card-text class="py-1" v-if="fromMenteeRegistration">
          {{ $t('Switch to mentee profile message - mentee registration') }}
        </b-card-text>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { BButton, BCardText, BCol, BModal, BRow } from "bootstrap-vue";
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  components: {
    BButton,
    BCardText,
    BCol,
    BModal,
    BRow
  },
  props: {
    fromMentoringPackages: {
      type: Boolean,
      default: false
    },
    fromMenteeRegistration: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs["switch-to-mentee-profile-modal"].show();
    },
    async switchAccount(accountType) {
      const accountSwitched = await this.$store.dispatch('user/switchAccount', accountType)
      if(accountSwitched) {
        this.$root.$bvToast.toast(this.$t('Switched to mentee profile'), {
          title: this.$t('Confirmation'),
          variant: 'success',
          solid: true,
        })
        this.$store.dispatch('mentor/clear')
        this.$refs["switch-to-mentee-profile-modal"].hide();
        const route = getHomeRouteForLoggedInUser(this.$store.getters['user/getUserRole'])
        if (this.$route.name !== route.name) {
          this.$router.push(route)
        }
      }
      else {
        this.$root.$bvToast.toast(this.$t('An error occured, please try again later'), {
          title: this.$t('Caution'),
          variant: 'danger',
          solid: true,
        })
        await this.$store.dispatch('user/logout')
        if (this.$route.name !== 'home') {
          this.$router.push({ name: 'home' })
        }
        return
      }
    }
  },
};
</script>

<style>

</style>
